// nameField differs per level because the backend does: Room/Device carry a
// name, Shelf/Rack/Box carry a label.
export const STORAGE_LEVELS = [
  {
    key: "room",
    endpoint: "rooms",
    nameField: "name",
    labelId: "storage.nav.room",
    label: "Room",
    parentKey: null,
    parentEndpoint: null,
    parentField: null,
    parentLabelId: null,
    parentLabel: null,
    addTitleId: "storage.add.room",
    addTitleDefault: "Add Room",
  },
  {
    key: "device",
    endpoint: "devices",
    nameField: "name",
    labelId: "storage.nav.device",
    label: "Device",
    parentKey: "room",
    parentEndpoint: "rooms",
    parentField: "parentRoomId",
    parentLabelId: "storage.nav.room",
    parentLabel: "Room",
    addTitleId: "storage.add.device",
    addTitleDefault: "Add Device",
  },
  {
    key: "shelf",
    endpoint: "shelves",
    nameField: "label",
    labelId: "storage.nav.shelf",
    label: "Shelf",
    parentKey: "device",
    parentEndpoint: "devices",
    parentField: "parentDeviceId",
    parentLabelId: "storage.nav.device",
    parentLabel: "Device",
    addTitleId: "storage.add.shelf",
    addTitleDefault: "Add Shelf",
  },
  {
    key: "rack",
    endpoint: "racks",
    nameField: "label",
    labelId: "storage.nav.rack",
    label: "Rack",
    parentKey: "shelf",
    parentEndpoint: "shelves",
    parentField: "parentShelfId",
    parentLabelId: "storage.nav.shelf",
    parentLabel: "Shelf",
    addTitleId: "storage.add.rack",
    addTitleDefault: "Add Rack",
  },
  {
    key: "box",
    endpoint: "boxes",
    nameField: "label",
    labelId: "storage.nav.box",
    label: "Box",
    parentKey: "rack",
    parentEndpoint: "racks",
    parentField: "parentRackId",
    parentLabelId: "storage.nav.rack",
    parentLabel: "Rack",
    addTitleId: "storage.add.box",
    addTitleDefault: "Add Box",
  },
];

export const storageLevel = (key) =>
  STORAGE_LEVELS.find((level) => level.key === key) || null;
